module.exports = __webpack_public_path__ + "assets/img/checked-1.002033cf.svg";